import React from 'react';
import { FiAlertTriangle as ExclamationTriangleIcon, FiXCircle as XCircleIcon } from 'react-icons/fi';
import { useTenantStatus } from '../../hooks/useTenantStatus';

const TenantStatusNotification = ({ tenant, className = "" }) => {
    const status = useTenantStatus(tenant);

    // Ne rien afficher si le tenant est actif et sans restrictions
    if (status.isActive && !status.isRestricted) return null;

    const getIcon = () => {
        if (status.isSuspended) {
            return XCircleIcon;
        }
        return ExclamationTriangleIcon;
    };

    const getColorClasses = () => {
        if (status.isSuspended) {
            return {
                bg: 'bg-orange-50 dark:bg-orange-900/20',
                border: 'border-orange-200 dark:border-orange-800',
                text: 'text-orange-800 dark:text-orange-200',
                icon: 'text-orange-600 dark:text-orange-400'
            };
        }
        
        // Note: Le statut 'cancelled' n'existe plus - les comptes annulés deviennent 'free' + 'active'

        return {
            bg: 'bg-blue-50 dark:bg-blue-900/20',
            border: 'border-blue-200 dark:border-blue-800',
            text: 'text-blue-800 dark:text-blue-200',
            icon: 'text-blue-600 dark:text-blue-400'
        };
    };

    const Icon = getIcon();
    const colors = getColorClasses();

    return (
        <div className={`p-4 rounded-lg border ${colors.bg} ${colors.border} ${className}`}>
            <div className="flex items-start space-x-3">
                <Icon className={`w-5 h-5 ${colors.icon} flex-shrink-0 mt-0.5`} />
                <div className="flex-1">
                    <h4 className={`text-sm font-medium ${colors.text}`}>
                        {status.getStatusMessage()}
                    </h4>
                    {status.restrictions.length > 0 && (
                        <ul className={`mt-2 text-sm ${colors.text} list-disc list-inside space-y-1`}>
                            {status.restrictions.map((restriction, index) => (
                                <li key={index}>{restriction}</li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TenantStatusNotification;